module.exports = __webpack_public_path__ + "static/media/Facebook.ef7e709c.svg";